import firebase from 'firebase/app'
import { DEMO_USER } from './demo-mode'

// Replaces the Firebase Auth and Realtime Database services with in-memory
// stubs so the demo build needs no Firebase project and never touches the
// network. Installed once at bootstrap (main.js), before any store action or
// HTTP request interceptor runs.
//
// Why a stub instead of "don't use firebase": many store modules read
// `firebase.auth().currentUser.uid` / `.getIdToken()` directly (device,
// nucleus, property, alarm, reading, statistic, active_alarms). Providing a
// fake currentUser keeps all of them working unchanged.
export function installFirebaseDemoStubs () {
  const currentUser = {
    uid: DEMO_USER.uid,
    email: DEMO_USER.email,
    displayName: DEMO_USER.displayName,
    getIdToken: () => Promise.resolve('demo-token')
  }

  const fakeAuth = {
    currentUser,
    onAuthStateChanged (callback) {
      // Resolve immediately as an authenticated session.
      Promise.resolve().then(() => callback(currentUser))
      return function unsubscribe () {}
    },
    signOut () {
      return Promise.resolve()
    },
    signInWithEmailAndPassword () {
      return Promise.resolve({ user: currentUser })
    },
    createUserWithEmailAndPassword () {
      return Promise.resolve({ user: currentUser })
    }
  }

  // A no-op Realtime Database ref. The one legitimate realtime reader
  // (services/realtime-status.js) is short-circuited to the demo provider
  // before it ever calls firebase.database(), so this only needs to keep the
  // incidental callers (auth writes, .info/connected) from throwing.
  const noopRef = {
    on () {},
    off () {},
    once () { return Promise.resolve({ val: () => null }) },
    set () { return Promise.resolve() },
    update () { return Promise.resolve() },
    child () { return noopRef }
  }

  const fakeDatabase = () => ({ ref: () => noopRef })
  fakeDatabase.ServerValue = { TIMESTAMP: Date.now() }

  // Use defineProperty so this works even if the SDK registered these as
  // non-writable accessors.
  Object.defineProperty(firebase, 'auth', { value: () => fakeAuth, configurable: true, writable: true })
  Object.defineProperty(firebase, 'database', { value: fakeDatabase, configurable: true, writable: true })
}



// WEBPACK FOOTER //
// ./src/demo/firebase-stub.js